import { FeaturedBrandInterface } from '../interfaces/featured-brand.interface';
import { Product } from '@core/models/piramide/Product';
import { todayInRange } from '@core/utils/date.util';
import { ArrayOrder, sortProps } from '@core/utils/array.util';
import { Brand } from '@core/models/piramide/Brand';
import { environment } from '@environments/environment';

type ProductsInfo = Pick<FeaturedBrandInterface['productos'][0], 'id_producto' | 'orden'>;

export class FeaturedBrandModel {
  private readonly _todayDate: Date = new Date();
  private readonly _validProducts: Array<ProductsInfo>;

  public readonly id: number = this._rawData.id_marca;
  public brand: Brand;
  public readonly link: string = this._rawData.link;
  public readonly disabled: boolean;
  public readonly logoName: string = this._rawData.nombre_archivo_logo;
  public readonly images: FeaturedBrandInterface['imagenes'] = this._rawData.imagenes.map(
    (img) => ({
      ...img,
      imagen: `${environment.apiImageStatic}/home_carrusel_marcas/${img.imagen}`,
    }),
  );
  public readonly order: number = this._rawData.orden;
  public readonly validFrom: Date | null =
    this._rawData.vigencia_desde ? new Date(this._rawData.vigencia_desde) : null;
  public readonly validUntil: Date | null =
    this._rawData.vigencia_hasta ? new Date(this._rawData.vigencia_hasta) : null;
  public readonly products: Product[];

  public get visible(): boolean {
    return todayInRange(
      this._todayDate,
      this.validFrom ?? this._todayDate,
      this.validUntil ?? this._todayDate,
    );
  }

  constructor(
    private _rawData: FeaturedBrandInterface,
    brandsIdx: Record<number, Brand>,
    productsTotalIdx: Record<number, Product>,
  ) {
    this._validProducts = this._rawData.productos.filter((p) => {
      const from: Date | null = p.vigencia_desde ? new Date(p.vigencia_desde) : null;
      const until: Date | null = p.vigencia_hasta ? new Date(p.vigencia_hasta) : null;

      return todayInRange(this._todayDate, from ?? this._todayDate, until ?? this._todayDate);
    });
    this.disabled = this._validProducts.length <= 0;
    sortProps(this._validProducts, ['orden'], ArrayOrder.asc);

    this.products = this._validProducts.reduce((acc, vp) => {
      const product = productsTotalIdx[vp.id_producto];
      if (product) acc.push(product);
      return acc;
    }, []);

    this.brand = brandsIdx[this.id];
  }
}
